<div class="wrapper w-full space-y-6 mt-6 leading-relaxed" *ngIf="hotel">
  <h2 class="w-full flex justify-start items-center text-xl font-bold tracking-tight ">
    قوانین و مقررات {{ hotel.Name }}
  </h2>
  <div class="grid grid-cols-2 md:grid-cols-4 gap-6 mt-4">
    <h3 class="justify-start items-start hidden font-bold md:flex">ساعت ورود و
      خروج</h3>
    <div class="grid grid-cols-1 gap-2 justify-center items-center">
      <div class="flex flex-col justify-center items-center bg-metal-50 rounded-md p-2">
        <div class="flex justify-center items-center text-black-300 gap-2">
          <div><i class="ico-TimeCircle flex justify-center items-center"></i></div>
          <div class="text-sm">ساعت ورود</div>
        </div>
        <div class="text-black font-bold">{{ hotel.Policies.CheckInTime ? hotel.Policies.CheckInTime : 'اعلام نشده' }}</div>
      </div>
      <div class="hidden justify-center space-x-1 items-center text-black-300 gap-2">
        <div><i class="ico-Check flex justify-center items-center"></i></div>
        <h3 class="text-sm">ورود زود هنگام</h3>
        <div><i class="ico-InformationCircle flex justify-center items-center"></i>
        </div>
      </div>
    </div>
    <div class="grid grid-cols-1 gap-2 justify-center items-center">
      <div class="flex flex-col justify-center items-center bg-metal-50 rounded-md p-2">
        <div class="flex justify-center items-center text-black-300 gap-2">
          <div><i class="ico-TimeCircle flex justify-center items-center"></i></div>
          <h3 class="text-sm">ساعت خروج</h3>
        </div>
        <div class="text-black font-bold">{{ hotel.Policies.CheckOutTime ? hotel.Policies.CheckOutTime : 'اعلام نشده' }}</div>
      </div>
      <div class="hidden justify-center space-x-1 items-center text-black-300 gap-2">
        <div><i class="ico-Check flex justify-center items-center"></i></div>
        <h3 class="text-sm hidden">خروج زود هنگام</h3>
        <div><i class="ico-InformationCircle flex justify-center items-center"></i></div>
      </div>
    </div>
  </div>
  <div
    *ngIf="hotel?.HotelSeasonNote && (hotel?.HotelSeasonNote?.HotelSeasonNote || hotel?.HotelSeasonNote?.HotelNoroozNote)"
    class="mt-4">
    <iho-season-tips [season]="hotel?.HotelSeasonNote?.HotelSeasonNote?.Season"
      [seasonNote]="hotel?.HotelSeasonNote?.HotelSeasonNote?.Descriptions" [hotelName]="hotel?.Name"
      [nowruz]="hotel?.HotelSeasonNote?.HotelNoroozNote ? true : false"
      [nowruzDescription]="hotel?.HotelSeasonNote?.HotelNoroozNote ? hotel?.HotelSeasonNote?.HotelNoroozNote?.Descriptions : []" />
  </div>
  <div class="grid grid-col-2 gap-6 justify-between items-start">
    <div class="grid grid-cols-1 md:grid-cols-7 mt-3 md:mt-6"
      *ngIf="!['', null, undefined].includes(hotel.PolicyHotelChecking) && hotel.PolicyHotelChecking as hotelCheckingPolicy">
      <div class="md:col-span-1 w-full text-base font-bold"></div>
      <div class="md:col-span-6 flex pr-8 text-blue-500 !text-lg !font-bold">
        <i class="ico-InformationCircle flex justify-center items-center"></i>
        <span *ngIf="hotelCheckingPolicy?.EarlyCheckInHour && !hotelCheckingPolicy?.LateCheckOutHour" class="mr-2">
          در این هتل امکان ورود زودهنگام وجود دارد
        </span>
        <span *ngIf="hotelCheckingPolicy?.LateCheckOutHour && !hotelCheckingPolicy?.EarlyCheckInHour" class="mr-2">
          در این هتل امکان خروج دیرهنگام وجود دارد
        </span>
        <span *ngIf="hotelCheckingPolicy?.EarlyCheckInHour && hotelCheckingPolicy?.LateCheckOutHour" class="mr-2">
          در این هتل امکان ورود زودهنگام و خروج دیرهنگام وجود دارد
        </span>
      </div>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-7 mt-3 md:mt-2"
      *ngIf="!['', null, undefined].includes(hotel.Policies.PolicyHotelChecking)">
      <div class="md:col-span-1 w-full text-base font-bold">قانون ورود و
        خروج</div>
      <div
        class="md:col-span-5 flex flex-col justify-start items-start text-black-300 space-y-3 pr-8 mt-2 md:mt-0 text-sm"
        [innerHTML]="hotel.Policies.PolicyHotelChecking">
      </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-7 mt-3 md:mt-6"
      *ngIf="!['', null, undefined].includes(hotel.Policies.PolicyHotelChild)">
      <div class="md:col-span-1 w-full text-base font-bold md:mt-0">قانون
        خردسال</div>
      <div
        class="md:col-span-5 flex flex-col justify-start items-start text-black-300 space-y-3 mt-2 pr-8 md:mt-0 text-sm"
        [innerHTML]="hotel.Policies.PolicyHotelChild">
      </div>
    </div>



    <div *ngIf="hotel.Policies.PolicyGroup" class="hidden md:grid grid-cols-6 mt-12">
      <div class="col-span-1 text-base text-black-500 font-bold">اطلاعات مهم
        دیگر</div>
      <div class="col-span-5 space-y-4">
          <div class *ngFor="let policy of hotel.Policies.PolicyGroup">
            <div class="text-base text-right leading-7">{{ policy?.Name }}</div>
            <div class="text-black-300 mt-2 text-sm !font-normal leading-7">
              <ul>
                <li *ngFor="let policy of policy.Policies" class="mb-1">{{
                  policy }}</li>
              </ul>
            </div>
          </div>
      </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-7 mt-3 md:mt-6"
      *ngIf="!['', null, undefined].includes(hotel.Policies.PolicyHotelCancellation)">
      <div class="md:col-span-1 w-full text-base font-bold md:mt-0">قانون کنسلی
        هتل</div>
      <div
        class="md:col-span-5 flex flex-col justify-start items-start text-black-300 space-y-3 leading-7 pr-8 mt-2 md:mt-0 text-sm"
        [innerHTML]="hotel.Policies.PolicyHotelCancellation">
      </div>
    </div>
  </div>
  <button mat-button color="primary" (click)="showModal()"
    class="!justify-self-start icon-arrow-button flex md:!hidden">
    <span>مشاهده همه ی قوانین</span>
    <i class="ico-Left text-2xl"></i>
  </button>
</div>